export default __webpack_public_path__ + "df17fcf9653f2236e6ddbdc4d4cf2d05.svg";